import {
  loginFailed,
  loginSuccess,
} from 'data/store/reducer/auth/actions/login';
import { iActionLogin } from 'domain/interfaces/redux/auth/login';
import { LoginAuth } from 'domain/usecases/auth/remote/LoginAuth';
import { makeRemoteLoginAuth } from 'main/factories/usecases/auth/LoginAuthFactory';
import { makeReduxActiveMessage } from 'main/factories/usecases/message/Update';
import { makeReduxOpenModal } from 'main/factories/usecases/modal/OpenModalFactory';
import { call, put } from 'redux-saga/effects';

export function* onLogin(action: iActionLogin) {
  const remoteLoginAuth = makeRemoteLoginAuth();

  try {
    const response: LoginAuth.Model = yield call(
      remoteLoginAuth.login,
      action.payload,
    );
    yield put(
      loginSuccess({
        ...response,
      }),
    );
  } catch (e: any) {
    yield put(loginFailed());

    if (action.payload?.body?.authMode === 'EXTERNAL') {
      const error = e?.data?.errors?.[0];

      if (error?.code === 'AUTH_EXTERNAL_TOKEN_INVALID') {
        makeReduxActiveMessage().active({
          active: 'externalLoginError',
          data: {
            email:
              error?.data?.login ??
              error?.email ??
              e?.data?.email ??
              e?.data?.user?.email,
          },
        });
      }
    }
  }
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onLoginSuccess() {
  // History.getHistory().push('/home');
  makeReduxOpenModal().open({});
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function onLoginFailed() {
  // toast.error('Credênciais inválidas.');
}
